const storeToken = (value) => {
  if (value) {
    localStorage.setItem("access", JSON.stringify(value.access));
    localStorage.setItem("refresh", JSON.stringify(value.refresh));
  }
}
const storeResponse = (value) => {
  if (value) {
      localStorage.setItem('user_type', value.user_type)
      localStorage.setItem('user_id', value.user_id)
      localStorage.setItem('com_name', value.com_name)
      localStorage.setItem('is_multiple', value.is_multiple)
  }
}
const getToken = () => {
  let access_token = localStorage.getItem('access')
  let user_type=   localStorage.getItem('user_type')
  let refresh_token = localStorage.getItem('refresh')
  return { access_token, refresh_token,user_type }
}

const removeToken = () => {
  localStorage.removeItem('access')
  localStorage.removeItem('refresh')
  localStorage.removeItem('com_name')
  localStorage.removeItem('user_type')
  localStorage.removeItem('user_id')
}

export { storeToken, getToken, removeToken ,storeResponse}